import Slider from "rc-slider"
import "rc-slider/assets/index.css"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export interface IScaleSliderV2Props {
    min: number
    max: number
    step?: number
    value: number
    minLabel?: string
    maxLabel?: string
    onChange: (value: number) => void
    isDisabled?: boolean
    name?: string
}

const ScaleSliderV2 = ({
    min = 0,
    max = 1,
    step,
    value,
    onChange,
    isDisabled = false,
    minLabel,
    maxLabel,
    name
}: IScaleSliderV2Props) => {
    const { i18n } = useTranslation()
    const isRTL = i18n.language === "he"

    const marks = useMemo(() => {
        const result: Record<number, string> = {}
        for (let i = min; i <= max; i += step) {
            result[i] = ""
        }
        return result
    }, [min, max, step])

    return (
        <div className="w-full">
            <div className="px-[16px] py-[18px]">
                <div className="relative w-full">
                    <Slider
                        {...{ min, max, step, value, onChange, name }}
                        disabled={isDisabled}
                        marks={marks}
                        reverse={isRTL}
                    />

                    <div
                        className="absolute top-1/2 left-0 w-full h-1  flex justify-between"
                        style={{ transform: "translateY(-50%)", direction: isRTL ? "rtl" : "ltr" }}
                    >
                        {Object.keys(marks).map((val) => (
                            <div
                                key={val}
                                className="w-[12px] h-[12px] opacity-[0.22] bg-black rounded-full"
                                style={{ pointerEvents: "none" }}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <div className="w-full flex items-center justify-between">
                {minLabel && <span className="text-sm font-medium text-[#6B7280]">{minLabel}</span>}
                {maxLabel && <span className="text-sm font-medium text-[#6B7280]">{maxLabel}</span>}
            </div>
        </div>
    )
}

export default ScaleSliderV2
